import { UseFormReturn } from "react-hook-form";
import { PatchPolicyFormValues } from "@/components/patching/schema";
import { Settings } from "@/components/patching/sections/settings/Settings";

interface SystemIntegrationSettingsProps {
  form: UseFormReturn<PatchPolicyFormValues>;
}

export function SystemIntegrationSettings({ form }: SystemIntegrationSettingsProps) {
  return <Settings form={form} />;
}